import $ from "jquery";
import 'slick-carousel';
import 'node_modules/slick-carousel/slick/slick-theme.scss';
import 'node_modules/slick-carousel/slick/slick.scss';

class CPM_FAQ_SLIDE {
    constructor() {
        this.init();

        $(window).on('load', this.init.bind(this));
        $(window).on('resize', this.init.bind(this));
        $(window).on('orientationchange', this.init.bind(this));
        $('#mainMenuModal').on('shown.bs.modal', function () {
            $(window).trigger('resize');
        })
    }

    static add_carousel(el, width, opt = []) {

    }

    static rm_carousel(el, width) {
        if (el !== 'undefined') {
            let slick = el.slick('getSlick');
            console.log('getSlick slide:', slick);
            if (slick) {
                console.log('unslick slide');
                el.slick('unslick')
            }
        }
    }

    static do_carousel(el, width) {
        el.slick({
            'arrows': false,
            'dots': true,
            'dotsClass': 'faq-dots',
            'appendDots': $('.faq-dots-container'),
            customPaging: function (slider, i) {
                let title = $(slider.$slides[i]).find('[data-title]').data('title');
                return '<a class="faq-dots-item"> ' + title + ' </a>';
            },
        });

        el.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            let active_dot = $(document).find('.faq-dots .slick-active');
            let dot_line_active = $(document).find('.faq-dots-line-active');
            let dot_line = $(document).find('.faq-dots-line');
            let w_w = $(window).width();

            if (w_w > 768) {
                if (active_dot) {
                    let active_dot_pos = active_dot.position();
                    let active_dot_value = active_dot_pos.left;

                    dot_line_active.css('top', '');

                    if (active_dot_value === 0) {
                        dot_line_active.css('left', active_dot_value + 'px')
                    } else {
                        if (active_dot_value < dot_line.width() - dot_line_active.width()) {
                            active_dot_value = active_dot_value - (dot_line_active.width() / 2 - active_dot.width() / 2);
                            dot_line_active.css('left', active_dot_value + 'px')
                        } else {
                            if (active_dot_value > 0) {
                                active_dot_value = dot_line.width() - dot_line_active.width();
                                dot_line_active.css('left', active_dot_value + 'px');
                            }
                        }
                    }
                }
            } else {
                if (active_dot) {
                    let active_dot_pos = active_dot.position();
                    let active_dot_value = active_dot_pos.top;

                    dot_line_active.css('left', '');

                    if (active_dot_value === 0) {
                        dot_line_active.css('top', active_dot_value + 'px')
                    } else {
                        if (active_dot_value < dot_line.height() - dot_line_active.height()) {
                            active_dot_value = active_dot_value - (dot_line_active.height() / 2 - active_dot.height() / 2);
                            dot_line_active.css('top', active_dot_value + 'px')
                        } else {
                            if (active_dot_value > 0) {
                                active_dot_value = dot_line.height() - dot_line_active.height();
                                dot_line_active.css('top', active_dot_value + 'px');
                            }
                        }
                    }
                }
            }

        });
    }

    init() {
        let w_w = $(window).width();

        CPM_FAQ_SLIDE.do_carousel($('.faq-slide'), w_w)
    }

    static reload() {
        let h_carousel = $(document).find('.sj-slide'),
            h_c_nb = h_carousel.length,
            w_w = $(window).width();

        if (h_c_nb) {
            h_carousel.each(function (i, el) {
                CPM_FAQ_SLIDE.do_carousel($(el), w_w)
            })
        }
    }
}

export default CPM_FAQ_SLIDE